var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { AchooInputComponent } from '../achoo-input/achoo-input.component';
import { ValidationHandlerService } from '../validation-handler.service';
var AchooToggleSwitchComponent = /** @class */ (function (_super) {
    __extends(AchooToggleSwitchComponent, _super);
    function AchooToggleSwitchComponent(validationHandlerService) {
        var _this = _super.call(this, validationHandlerService) || this;
        _this.validationHandlerService = validationHandlerService;
        _this.switchChange = new EventEmitter();
        return _this;
    }
    AchooToggleSwitchComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    AchooToggleSwitchComponent.prototype.switchChangeEvent = function (model) {
        this.switchChange.emit(model);
    };
    return AchooToggleSwitchComponent;
}(AchooInputComponent));
export { AchooToggleSwitchComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-toggle-switch/achoo-toggle-switch.component.ts.pre-build-optimizer.js